<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<lgb-back name="sign"></lgb-back>
	<h1 class="text-primary mt-4 mb-2">Conditions générales de vente</h1>
	<h2 class="text-primary text-lg">1. Objet</h2>
	<p class="mb-4 text-xs text-justify">
		Les présentes Conditions Générales de Vente (CGV) ont pour objet de définir les conditions dans lesquelles l'éditeur propose l'accès à l'application Legend-Binder ainsi que les modalités de souscription aux services proposés.<br/>
		Toute souscription implique l'acceptation sans réserve des présentes CGV.
	</p>
	<h2 class="text-primary text-lg">2. Identité de l'éditeur</h2>
	<p class="mb-4 text-xs text-justify">
		Le service est édité par une entreprise individuelle (micro-entreprise), opérant sous le nom commercial Legend-Binder.<br/>
		Les informations légales complètes (identité, adresse, SIRET, contact) sont disponibles dans les mentions légales.
	</p>
	<h2 class="text-primary text-lg">3. Description du service</h2>
	<div class="mb-4 text-xs text-justify">
		L'application Legend-Binder permet notamment :
		<ul class="list-disc pl-5">
			<li>la gestion de collections de cartes</li>
			<li>la visualisation de classeurs numériques</li>
			<li>l'accès à des données indicatives relatives aux cartes</li>
		</ul>
		Les informations fournies sont communiquées à titre strictement informatif et sans valeur contractuelle.
	</div>
	<h2 class="text-primary text-lg">4. Accès au service</h2>
	<div class="mb-4 text-xs text-justify">
		L'accès au service nécessite la création d'un compte utilisateur.
		L'utilisateur s'engage à :
		<ul class="list-disc pl-5">
			<li>fournir des informations exactes</li>
			<li>maintenir la confidentialité de ses identifiants</li>
		</ul>
		Toute utilisation frauduleuse ou non autorisée engage la responsabilité de l'utilisateur.
	</div>
	<h2 class="text-primary text-lg">5. Abonnement</h2>
	<div class="mb-4 text-xs text-justify">
		Le service est proposé sous forme d'abonnement annuel :
		<ul class="list-disc pl-5">
			<li>Prix : 29,90 € TTC</li>
			<li>Durée : 12 mois</li>
			<li>Date de début : date de validation du paiement</li>
		</ul>
		L'abonnement est payable en une seule fois.<br/>
		Il n'est pas reconduit automatiquement à son échéance.
	</div>
	<h2 class="text-primary text-lg">6. Paiement</h2>
	<p class="mb-4 text-xs text-justify">
		Le paiement est effectué via des prestataires de paiement sécurisés, notamment Stripe et PayPal.<br/>
		En cas d'échec du paiement, l'accès au service pourra être suspendu ou refusé.
	</p>
	<h2 class="text-primary text-lg">7. Droit de rétractation</h2>
	<p class="mb-4 text-xs text-justify">
		Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les services pleinement exécutés avant la fin du délai de rétractation.<br/>
		En validant son paiement, l'utilisateur :<br/>
		reconnaît et accepte expressément que l'exécution du service commence immédiatement après validation du paiement et renonce expressément à son droit de rétractation.
	</p>
	<h2 class="text-primary text-lg">8. Durée et résiliation</h2>
	<p class="mb-4 text-xs text-justify">
		L'abonnement est conclu pour une durée ferme de 12 mois.<br/>
		Il ne peut être résilié avant son échéance.<br/>
		Aucun remboursement ne sera effectué en cours de période, y compris en cas de non-utilisation du service.
	</p>
	<h2 class="text-primary text-lg">9. Responsabilité</h2>
	<div class="mb-4 text-xs text-justify">
		Les informations accessibles via l'application sont :
		<ul class="list-disc pl-5">
			<li>indicatives</li>
			<li>non contractuelles</li>
			<li>susceptibles d'évoluer à tout moment</li>
		</ul>
		L'éditeur ne garantit en aucun cas :
		<ul class="list-disc pl-5">
			<li>l'exactitude</li>
			<li>la fiabilité</li>
			<li>l'exhaustivité des données</li>
		</ul>
		L'utilisateur est seul responsable de l'utilisation qu'il fait des informations fournies, notamment dans le cadre de décisions d'achat, de vente ou d'évaluation.<br/>
		L'éditeur ne pourra être tenu responsable de toute perte financière, perte d'opportunité ou préjudice indirect.
	</div>
	<h2 class="text-primary text-lg">10. Disponibilité du service</h2>
	<div class="mb-4 text-xs text-justify">
	Le service est accessible en continu, sous réserve :
		<ul class="list-disc pl-5">
			<li>d'opérations de maintenance</li>
			<li>d'évolutions techniques</li>
			<li>de cas de force majeure</li>
		</ul>
		L'éditeur se réserve le droit d'interrompre temporairement l'accès au service sans indemnité.
	</div>
	<h2 class="text-primary text-lg">11. Propriété intellectuelle</h2>
	<p class="mb-4 text-xs text-justify">
		L'ensemble des éléments composant l'application Legend-Binder est protégé par le droit de la propriété intellectuelle.<br/>
		Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation expresse est interdite.
	</p>
	<h2 class="text-primary text-lg">12. Interdictions d'usage</h2>
	<div class="mb-4 text-xs text-justify">
		Il est strictement interdit de :

		<ul class="list-disc pl-5">
			<li>procéder à toute extraction automatisée de données (scraping)</li>
			<li>utiliser des robots, scripts ou outils automatisés</li>
			<li>extraire ou réutiliser massivement les données du service</li>
			<li>tenter d'accéder aux systèmes de manière non autorisée</li>
			<li>porter atteinte au fonctionnement du service</li>
			<li>procéder à toute opération de rétro-ingénierie, décompilation ou désassemblage</li>
		</ul>
		Toute violation pourra entraîner la suspension ou la suppression du compte, sans préjudice de poursuites.
	</div>
	<h2 class="text-primary text-lg">13. Données personnelles</h2>
	<p class="mb-4 text-xs text-justify">
		Les données personnelles sont traitées conformément à la réglementation en vigueur.<br/>
		Une politique de confidentialité distincte précise les modalités de traitement.
	</p>
	<h2 class="text-primary text-lg">14. Suspension ou suppression de compte</h2>
	<div class="mb-4 text-xs text-justify">
		L'éditeur se réserve le droit de suspendre ou supprimer tout compte utilisateur en cas de :
		<ul class="list-disc pl-5">
			<li>non-respect des présentes CGV</li>
			<li>fraude ou tentative de fraude</li>
			<li>usage abusif ou détourné du service</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">15. Force majeure</h2>
	<p class="mb-4 text-xs text-justify">
		L'éditeur ne pourra être tenu responsable en cas de survenance d'un événement de force majeure empêchant l'exécution du service.
	</p>
	<h2 class="text-primary text-lg">16. Modification des CGV et des prix</h2>
	<div class="mb-4 text-xs text-justify">
		L'éditeur se réserve le droit de modifier à tout moment les présentes CGV ainsi que les tarifs applicables.<br/>
		Les modifications entrent en vigueur dès leur mise en ligne.<br/>
		L'utilisateur est invité à consulter régulièrement les CGV.<br/>
		L'éditeur ne saurait être tenu de notifier individuellement les utilisateurs des modifications.
	</div>
	<h2 class="text-primary text-lg">17. Droit applicable</h2>
	<p class="mb-4 text-xs text-justify">
		Les présentes CGV sont soumises au droit français.
	</p>
	<h2 class="text-primary text-lg">18. Contact</h2>
	<p class="mb-4 text-xs text-justify">
		Pour toute question ou réclamation :
		anthony@legend-binder.com
	</p>
</div>
